// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";

function V3CustomTableRow(props) {
  var children = props.children;
  var match = Curry._1(V3CustomTableContext$LiteracyplanetTupperware.use, undefined);
  if (match.t === "InstructionAndHint") {
    return React.createElement("div", {
                className: ""
              }, children);
  } else {
    return React.createElement("div", {
                className: "grid grid-cols-9 flex"
              }, children);
  }
}

var make = V3CustomTableRow;

var $$default = V3CustomTableRow;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
